export default () => ({
    quote_calculated: {}
})